import { makeStyles, Theme } from '@material-ui/core';

export default makeStyles<Theme>(() => ({
  address: {
    fontSize: '0.85em',
    fontWeight: 500,
  },
}));
